import React, { ReactNode, useEffect } from 'react';
import { useIntegrations } from './hooks/integrations';
import Intercom, { update, shutdown } from '@intercom/messenger-js-sdk';
import { INTEGRATION_TYPES } from 'shared/constants/integrations';

export const IntegrationsContext = React.createContext<object | null>(null);

const IntegrationsProvider = ({ children }: { children: ReactNode }) => {
  const intergrationClient = useIntegrations();
  const { getIntegration, integrationAccessLevel } = intergrationClient;
  const intercomIntegration = getIntegration(INTEGRATION_TYPES.INTERCOM);

  useEffect(() => {
    if (!intercomIntegration?.id || intercomIntegration?.status !== 'active') {
      return;
    }
    const { configurationData } = intercomIntegration;
    const user = integrationAccessLevel.user;

    if (
      integrationAccessLevel.authenticated &&
      user &&
      configurationData?.key
    ) {
      if (user.intercom_hash) {
        // Secure mode: identity verification enabled — single boot with user_hash
        Intercom({
          app_id: configurationData.key,
          user_id: user.id,
          name: user.fullName,
          email: user.email,
          phone: user.phone,
          user_hash: user.intercom_hash
        });
      } else {
        // Legacy mode: no secret configured — boot anonymous then update with user attrs
        Intercom({ app_id: configurationData.key });
        update({
          user_id: user.id,
          name: user.fullName,
          email: user.email
        });
      }
    }

    return () => {
      shutdown();
    };
  }, [
    intercomIntegration?.id,
    intercomIntegration?.status,
    integrationAccessLevel.authenticated
  ]);

  return (
    <IntegrationsContext.Provider value={intergrationClient}>
      {children}
    </IntegrationsContext.Provider>
  );
};

export default IntegrationsProvider;
